import { SVGProps } from "react";

const TriggerCloseIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="rgba(255,255,255,0)" d="M0 0h16v16H0z" data-name="Rectangle 486" />
      <path
        fill="currentColor"
        d="M11.552 8.298a.328.328 0 0 0 0-.465l-.536-.536a.328.328 0 0 0-.47.005L8.711 9.225v-4.4a.329.329 0 0 0-.328-.328h-.766a.329.329 0 0 0-.328.328v4.4L5.454 7.303a.328.328 0 0 0-.47-.005l-.536.536a.328.328 0 0 0 0 .465l3.32 3.32a.328.328 0 0 0 .465 0Zm2.573-5.111a1.313 1.313 0 0 0-1.312-1.312H3.187a1.313 1.313 0 0 0-1.312 1.313v9.625a1.313 1.313 0 0 0 1.312 1.312h9.625a1.313 1.313 0 0 0 1.313-1.312Zm-1.313 9.463a.165.165 0 0 1-.164.164h-9.3a.165.165 0 0 1-.161-.164v-9.3a.165.165 0 0 1 .164-.164h9.3a.165.165 0 0 1 .164.164Z"
        data-name="Path 4616"
      />
    </svg>
  );
};

export default TriggerCloseIcon;
